import API from './api';
import GLOBALS from "./GLOBALS";

const logout_url = '/auth/logout';
const change_password_url = '/auth/';
const reset_password_url = '/auth/password';
const register_url = '/auth/register';



export const buildUrlFor = model => `${API.defaults.baseURL}/${model}/`;

export const Urls = {
    api: process.env.REACT_APP_API_URL,

    ApiLogIn: API.defaults.baseURL,
    ApiLogOut: API.defaults.baseURL + logout_url,
    ApiChangePassword: API.defaults.baseURL + change_password_url,
    ApiResetPassword: API.defaults.baseURL + reset_password_url,
    ApiRegister: API.defaults.baseURL + register_url,

    ApiInstitution: GLOBALS.ENDPOINTS.INSTITUTION.LIST + "/0",
    ApiMedRecords: GLOBALS.ENDPOINTS.MEDRECORDS.LIST_INST + "/",
    ApiMedRecordModify: GLOBALS.ENDPOINTS.MEDRECORDS.MODIFY + "/",
    ApiMedRecordGet: GLOBALS.ENDPOINTS.MEDRECORDS.GET_INST + "/",
    ApiSetInst: GLOBALS.ENDPOINTS.PORTAL_USER.SET_INST + "/",
    ApiExtrasGet: GLOBALS.ENDPOINTS.MEDRECORDS.GET_ALL_STD,
    ApiExtrasMod: GLOBALS.ENDPOINTS.MEDRECORDS.MOD_STD_STRING + "/",
    ApiGetPortalUser: GLOBALS.ENDPOINTS.PORTAL_USER.GET + "/",
    ApiListOwnInstitutions: GLOBALS.ENDPOINTS.INSTITUTION.LIST_OWN + "/0",

}

API.interceptors.response.use(
  function (response) {
    // Any 2xx status code
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);


// dev api: ' https://devapi.viewmind.net/'
// prod api: 'https://eu-api.viewmind.ai/'
